import { Expose, Type } from 'class-transformer';
import { MyActivityWithRelationsImpl } from './my-activity-with-relations.impl';
import { MyActivityAllocDto } from '../../room/dto/response/my-activity-alloc.dto';
import { MyActivitiesTypeEnum } from '../../event/dto/enums/my-activities-type.enum';
import { ResourceResponseDto } from '../../room/dto/response/get-resources-response.dto';

export class MyActivityResourceImpl extends MyActivityWithRelationsImpl {
  @Expose({ name: 'alloc' })
  @Type(() => MyActivityAllocDto)
  alloc: MyActivityAllocDto;
  @Expose({ name: 'resource' })
  @Type(() => ResourceResponseDto)
  resource: ResourceResponseDto;
  @Expose({ name: 'type' })
  type:
    | MyActivitiesTypeEnum.MEETING_ROOM
    | MyActivitiesTypeEnum.GYM
    | MyActivitiesTypeEnum.LOUNGE
    | MyActivitiesTypeEnum.EVENT_SPACE
    | MyActivitiesTypeEnum.ROOF_TOP;
}
